export default __webpack_public_path__ + "static/media/ic-supp-baleage.ad5585f5.svg";